import { VendorApplication } from "../models/vendor-models";
import { CustomerType } from "../models/enums";

/**
 * Returns true if the necessary fields for a quote to be generated are present.
 * @see CaptureDialog (in libs/ng-shared) for required fields and validators - View the actual "form" and its validators.
 */
export function canQuoteBeRequested(application: VendorApplication): boolean {
  const customer = application.patients.find(p => p.customerType === CustomerType.PatientDebtorAndAuthorizer || p.customerType === CustomerType.PatientAndDebtor || p.customerType === CustomerType.Debtor);
  if (!customer) return false;
  if (!customer.email || !customer.firstName || !customer.identityNumber || !customer.identityType || !customer.mobileNumber) return false;

  if (!application.loanAmount || !application.startDate || !application.instalments) return false;

  if (!application.vendorId) return false;
  if (!application.id || !application.reference) return false;

  return true;
}
